import {
  CREATE_OR_UPDATE_ADS,
  CREATE_OR_UPDATE_ADS_ERROR,
  CREATE_OR_UPDATE_ADS_IMAGE_LOCATION,
  CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_ERROR,
  CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_RESET,
  CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_SUCCESS,
  CREATE_OR_UPDATE_ADS_IMAGE_TYPE,
  CREATE_OR_UPDATE_ADS_IMAGE_TYPE_ERROR,
  CREATE_OR_UPDATE_ADS_IMAGE_TYPE_RESET,
  CREATE_OR_UPDATE_ADS_IMAGE_TYPE_SUCCESS,
  CREATE_OR_UPDATE_ADS_RESET,
  CREATE_OR_UPDATE_ADS_SUCCESS,
  CREATE_OR_UPDATE_ADS_TYPE,
  CREATE_OR_UPDATE_ADS_TYPE_ERROR,
  CREATE_OR_UPDATE_ADS_TYPE_RESET,
  CREATE_OR_UPDATE_ADS_TYPE_SUCCESS,
  GET_AD_BANNER,
  GET_AD_BANNER_ERROR,
  GET_AD_BANNER_SUCCESS,
  GET_ADS,
  GET_ADS_ERROR,
  GET_ADS_IMAGE_LOCATION,
  GET_ADS_IMAGE_LOCATION_ERROR,
  GET_ADS_IMAGE_LOCATION_SUCCESS,
  GET_ADS_IMAGE_TYPE,
  GET_ADS_IMAGE_TYPE_ERROR,
  GET_ADS_IMAGE_TYPE_SUCCESS,
  GET_ADS_SUCCESS,
  GET_ADS_TYPE,
  GET_ADS_TYPE_ERROR,
  GET_ADS_TYPE_SUCCESS,
} from "../actions/adsAction";

const initialState = {
  adBannerData: {},
  adBannerLoading: {},
  adBannerError: {},

  adTypeData: {},
  adTypeLoading: {},
  adTypeError: {},

  adImageLocationData: {},
  adImageLocationLoading: {},
  adImageLocationError: {},

  adImageTypeData: {},
  adImageTypeLoading: {},
  adImageTypeError: {},

  data: {},
  loading: false,
  saving: false,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CREATE_OR_UPDATE_ADS:
      return {
        ...state,
        saving: true,
        error: null,
      };

    case CREATE_OR_UPDATE_ADS_SUCCESS:
      return {
        ...state,
        saving: false,
        data: action.payload.success,
      };

    case CREATE_OR_UPDATE_ADS_ERROR:
      return {
        ...state,
        saving: false,
        error: action.payload.error,
        data: {},
      };

    case CREATE_OR_UPDATE_ADS_RESET:
      return {
        ...state,
        saving: false,
        error: null,
        data: {},
      };

    case GET_ADS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_ADS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.success,
      };

    case GET_ADS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        data: [],
      };

    case CREATE_OR_UPDATE_ADS_TYPE:
      return {
        ...state,
        saving: true,
        error: null,
      };

    case CREATE_OR_UPDATE_ADS_TYPE_SUCCESS:
      return {
        ...state,
        saving: false,
        data: action.payload.success,
      };

    case CREATE_OR_UPDATE_ADS_TYPE_ERROR:
      return {
        ...state,
        saving: false,
        error: action.payload.error,
        data: {},
      };

    case CREATE_OR_UPDATE_ADS_TYPE_RESET:
      return {
        ...state,
        saving: false,
        error: null,
        data: {},
      };

    case GET_ADS_TYPE:
      return {
        ...state,
        adTypeLoading: true,
        adTypeError: null,
      };

    case GET_ADS_TYPE_SUCCESS:
      return {
        ...state,
        adTypeLoading: false,
        adTypeData: action.payload.success,
      };

    case GET_ADS_TYPE_ERROR:
      return {
        ...state,
        adTypeLoading: false,
        adTypeError: action.payload.error,
        adTypeData: [],
      };

    case CREATE_OR_UPDATE_ADS_IMAGE_LOCATION:
      return {
        ...state,
        saving: true,
        error: null,
      };

    case CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_SUCCESS:
      return {
        ...state,
        saving: false,
        data: action.payload.success,
      };

    case CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_ERROR:
      return {
        ...state,
        saving: false,
        error: action.payload.error,
        data: {},
      };

    case CREATE_OR_UPDATE_ADS_IMAGE_LOCATION_RESET:
      return {
        ...state,
        saving: false,
        error: null,
        data: {},
      };

    case GET_ADS_IMAGE_LOCATION:
      return {
        ...state,
        adImageLocationLoading: true,
        adImageLocationError: null,
      };

    case GET_ADS_IMAGE_LOCATION_SUCCESS:
      return {
        ...state,
        adImageLocationLoading: false,
        adImageLocationData: action.payload.success,
      };

    case GET_ADS_IMAGE_LOCATION_ERROR:
      return {
        ...state,
        adImageLocationLoading: false,
        adImageLocationError: action.payload.error,
        adImageLocationData: [],
      };

    case CREATE_OR_UPDATE_ADS_IMAGE_TYPE:
      return {
        ...state,
        saving: true,
        error: null,
      };

    case CREATE_OR_UPDATE_ADS_IMAGE_TYPE_SUCCESS:
      return {
        ...state,
        saving: false,
        data: action.payload.success,
      };

    case CREATE_OR_UPDATE_ADS_IMAGE_TYPE_ERROR:
      return {
        ...state,
        saving: false,
        error: action.payload.error,
        data: {},
      };

    case CREATE_OR_UPDATE_ADS_IMAGE_TYPE_RESET:
      return {
        ...state,
        saving: false,
        error: null,
        data: {},
      };

    case GET_ADS_IMAGE_TYPE:
      return {
        ...state,
        adImageTypeLoading: true,
        adImageTypeError: null,
      };

    case GET_ADS_IMAGE_TYPE_SUCCESS:
      return {
        ...state,
        adImageTypeLoading: false,
        adImageTypeData: action.payload.success,
      };

    case GET_ADS_IMAGE_TYPE_ERROR:
      return {
        ...state,
        adImageTypeLoading: false,
        adImageTypeError: action.payload.error,
        adImageTypeData: [],
      };

    case GET_AD_BANNER:
      return {
        ...state,
        adBannerLoading: true,
        adBannerError: null,
      };

    case GET_AD_BANNER_SUCCESS:
      return {
        ...state,
        adBannerLoading: false,
        adBannerData: action.payload.success,
      };

    case GET_AD_BANNER_ERROR:
      return {
        ...state,
        adBannerLoading: false,
        adBannerError: action.payload.error,
        adBannerData: [],
      };

    default:
      return state;
  }
}
